// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // 👈 1. Yeh import add kiya
import { CartProvider } from './context/CartContext';
import App from './App';
import './App.css'; 

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
    <CartProvider> {/* 👈 2. App ko iske andar wrap kiya */}
      <App />
      </CartProvider>
    </BrowserRouter>
  </React.StrictMode>
);